
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-43ff2910\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":false}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ExtraSelector.vue")

var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ExtraSelector.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-43ff2910\"}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ExtraSelector.vue"),
  /* scopeId */
  "data-v-43ff2910",
  /* cssModules */
  null
)
Component.options.__file = "/github/workspace/src/components/reservations/NewReservation/Resume/AddExtra/ExtraSelector.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ExtraSelector.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-43ff2910", Component.options)
  } else {
    hotAPI.reload("data-v-43ff2910", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/reservations/NewReservation/Resume/AddExtra/ExtraSelector.vue
// module id = 426
// module chunks = 0